export class EstadoInfoFiviI{
	id : BigInteger;
  idFuente : any;
  idPeriodo : any;
  estado : String;
  estadocargue : String;
  novedadSis : String;
  novedadUsu : String;
  observacionSis : String;
  observacionFte : String;
  fecha : String;
  numeroErrores : any;
}
